import { ReactElement, useMemo } from 'react';
import { GridColumnMenu, GridColumnMenuProps } from '@enterprise/material-data-grid';
import styles from './combinedItemCustomColumnMenu.module.scss';
import i18n from '../../../../../i18n';
import { CombinedItemsGridColumn } from '../hooks';
import classNames from 'classnames';
import { CombinedItemBulkUpdateType, CombinedItemsSelectionModel } from '../../../../../store';

export interface ItemResultsProps {
    selection?: CombinedItemsSelectionModel;
    onBulkActionChange?: (props: { type: CombinedItemBulkUpdateType }) => void;
}

export const combinedItemCustomColumnMenu = ({ selection, onBulkActionChange }: ItemResultsProps) =>
    function combinedItemCustomColumnMenuComponent(props: GridColumnMenuProps): ReactElement {
        const { hideMenu, colDef, color, ...other } = props;
        const field = colDef.field as CombinedItemsGridColumn;
        const customMenuColumn = useMemo<{ type: CombinedItemBulkUpdateType; name: string } | undefined>(() => {
            return (
                (field.includes(CombinedItemBulkUpdateType.Description) && {
                    type: CombinedItemBulkUpdateType.Description,
                    name: i18n.t('controlCenter:columnHeaderMenus:bulkUpdateDescription', 'Bulk Update Description'),
                }) ||
                (field.includes(CombinedItemBulkUpdateType.HideZeroAmounts) && {
                    type: CombinedItemBulkUpdateType.HideZeroAmounts,
                    name: i18n.t('controlCenter:columnHeaderMenus:bulkUpdateDescription', 'Bulk Update Description'),
                }) ||
                undefined
            );
        }, [colDef]);

        return (
            <>
                <GridColumnMenu
                    data-automation-id={`${field}-header-menu`}
                    hideMenu={hideMenu}
                    colDef={colDef}
                    // todo: check if selection required to apply css class
                    className={classNames({ [styles.gridColumnMenu]: Boolean(customMenuColumn && selection) })}
                    {...other}
                />
                {/*TODO: uncomment this part when implement bulk update per grid property*/}
                {/*<Divider />*/}
                {/*{customMenuColumn && selection && (*/}
                {/*    <div className={styles.headerMenuCustomItemContainer} data-automation-id={`${field}-update-menu-item`}>*/}
                {/*        <div*/}
                {/*            className={classNames(styles.headerMenuCustomItem, {*/}
                {/*                [styles.disabled]: !selection.items?.size && !selection.excluded?.size && !selection.all,*/}
                {/*            })}*/}
                {/*            onClick={(event) => {*/}
                {/*                hideMenu(event);*/}
                {/*                onBulkActionChange?.({ type: customMenuColumn.type });*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            {customMenuColumn.name}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*)}*/}
            </>
        );
    };
